import {
  firstNameOf,
  renderPortalCopy,
  type PortalSessionResponse,
} from "@ledgerbox/domain"

/** The client home's heading and lede in the firm's words; null keeps the
    page's own line. */
export type HomeCopy = { heading: string | null; lede: string | null }

/**
 * The firm's own greeting and message for the client home, filled for the
 * person signed in. Null means the firm has not set that line, or it came out
 * blank once filled, and the page keeps its own words.
 */
export const homeCopy = (
  session: PortalSessionResponse,
  firmName: string
): HomeCopy => {
  const values = {
    first_name: firstNameOf(session.contact.name),
    client_name: session.workspace.clientCompanyName ?? session.workspace.name,
    firm_name: firmName,
  }
  const fill = (template: string | null | undefined) =>
    template?.trim() ? renderPortalCopy(template, values) || null : null
  return {
    heading: fill(session.branding.homeGreeting),
    lede: fill(session.branding.homeMessage),
  }
}
